import { mockLabels } from '@web/lib/demo/data/labels';
export var getAllLabels = function () {
    var result = mockLabels.map(function (label) {
        var rules = label.rules.map(function (rule, ruleIndex) { return ({
            id: ruleIndex + 1,
            activityLabelId: label.id,
            target: rule.target,
            conditions: rule.conditions,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        }); });
        return {
            id: label.id,
            name: label.name,
            workspaceId: 1,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            rules: rules
        };
    });
    return result;
};
